import { validateEntry } from "../../apiLoader/user";
import { get } from "svelte/store";
import { userStore } from "../../stores/user";
import { NavigationType } from "../../stores/session";
import { navigateTo } from "../../routing";

export type EntryGateInput = {
  type: "text" | "email" | "tel" | "number";
  name: string;
  label: string;
  maxLength: number;
};

export const setupEntryGate = (entryGateInputs: EntryGateInput[]) => {
  const entryGateData = entryGateInputs.reduce((acc, { name }) => {
    acc[name] = "";
    return acc;
  }, {} as Record<string, string>);
  userStore.update((data) => ({ ...data, entryGateData }));
};

export const validateAndContinue = async () => {
  const entryGateData = get(userStore).entryGateData;
  try {
    await validateEntry(entryGateData);
    navigateTo(NavigationType.Next);
    return true;
  } catch (error) {
    return false;
  }
};
